"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFormattedDate = void 0;
const date_fns_1 = require("date-fns");
const getFormattedDate = (date, formatType) => {
    return (0, date_fns_1.format)(new Date(date), formatType);
};
exports.getFormattedDate = getFormattedDate;
